var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:{
		container: true,
		clickable: _vm.clickable,
		active: _vm.active,
	}},_vm.$listeners),[(_vm.item.type === 'category')?_c('CategoryItem',{attrs:{"item":_vm.item}}):(_vm.item.type === 'subcategory')?_c('SubcategoryItem',{attrs:{"item":_vm.item}}):(_vm.item.type === 'node')?_c('NodeItem',{attrs:{"nodeType":_vm.item.properties.nodeType,"bordered":!_vm.lastNode},on:{"dragstart":_vm.$listeners.dragstart,"dragend":_vm.$listeners.dragend}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }